const nasobilkaOsmi = () => {
	return [
		{
			id: 1,
			priklad: '1 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '32',
				},
			],
			vysledek: '8',
		},
		{
			id: 2,
			priklad: '7 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '48',
				},
				{
					id: 2,
					moznost: '64',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '56',
		},
		{
			id: 3,
			priklad: '3 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '32',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '24',
		},
		{
			id: 4,
			priklad: '9 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '80',
				},
				{
					id: 2,
					moznost: '56',
				},
				{
					id: 3,
					moznost: '64',
				},
				{
					id: 4,
					moznost: '72',
				},
			],
			vysledek: '72',
		},
		{
			id: 5,
			priklad: '5 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '48',
				},
				{
					id: 3,
					moznost: '32',
				},
				{
					id: 4,
					moznost: '56',
				},
			],
			vysledek: '40',
		},
		{
			id: 6,
			priklad: '2 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '32',
				},
			],
			vysledek: '16',
		},
		{
			id: 7,
			priklad: '8 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '48',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '32',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '32',
		},
		{
			id: 8,
			priklad: '6 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '32',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '48',
				},
			],
			vysledek: '48',
		},
		{
			id: 9,
			priklad: '8 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '64',
				},
				{
					id: 2,
					moznost: '56',
				},
				{
					id: 3,
					moznost: '72',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '64',
		},
		{
			id: 10,
			priklad: '8 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '72',
				},
				{
					id: 2,
					moznost: '80',
				},
				{
					id: 3,
					moznost: '64',
				},
				{
					id: 4,
					moznost: '56',
				},
			],
			vysledek: '80',
		},
		{
			id: 11,
			priklad: '16 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '2',
		},
		{
			id: 12,
			priklad: '80 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '10',
		},
		{
			id: 13,
			priklad: '8 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '1',
		},
		{
			id: 14,
			priklad: '40 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '5',
		},
		{
			id: 15,
			priklad: '64 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '8',
		},
		{
			id: 16,
			priklad: '24 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '3',
		},
		{
			id: 17,
			priklad: '16 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '2',
		},
		{
			id: 18,
			priklad: '8 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '1',
		},
		{
			id: 19,
			priklad: '32 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '4',
		},
		{
			id: 20,
			priklad: '0 : 8',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '0',
		},
		{
			id: 21,
			priklad: '8 x 1',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '8',
		},
		{
			id: 22,
			priklad: '8 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '63',
				},
				{
					id: 2,
					moznost: '42',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '56',
		},
		{
			id: 23,
			priklad: '8 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '32',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '24',
		},
		{
			id: 24,
			priklad: '8 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '56',
				},
				{
					id: 2,
					moznost: '64',
				},
				{
					id: 3,
					moznost: '72',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '72',
		},
		{
			id: 25,
			priklad: '8 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '50',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '40',
				},
				{
					id: 4,
					moznost: '45',
				},
			],
			vysledek: '40',
		},
		{
			id: 26,
			priklad: '8 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '16',
		},
		{
			id: 27,
			priklad: '4 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '32',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '32',
		},
		{
			id: 28,
			priklad: '8 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '54',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '48',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '48',
		},
		{
			id: 29,
			priklad: '10 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '56',
				},
				{
					id: 2,
					moznost: '64',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '72',
				},
			],
			vysledek: '80',
		},
	];
};

export default nasobilkaOsmi;
